__turbopack_context__.v({
  "layout__wrapper": "styles-module__5MCMVq__layout__wrapper",
});
